import { Feature } from "features/interfaces";
import { actions, reducer } from "./ducks";
import saga from "./saga";

export const missionsManagerFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions
};
